// si pas de 100% annulable on propose le flex
import { createSelector } from "reselect";
import get from "lodash/get";
import { INSURANCE_STANDARD, SPECIAL_OFFER_TYPES } from "app/constants";
import { calculateFlexIncluded } from "app/utils/quotationUtils";
import { getSpecialOffer } from "app/pages/FicheProduit/ficheProduitSelector";
import {
	getQuotationInsurances,
	getQuoteSpecialOffer,
} from "app/pages/Booking/Quotation/quotationSelectors";
import {
	calculateQuoteBaseAndExtrasTotal,
	getFlight,
	getPassengers,
} from "app/pages/Booking/bookingSelectors";

export const shouldEnableFlexRateChoice = createSelector(
	[getSpecialOffer, getQuoteSpecialOffer, getFlight, getQuotationInsurances],
	(specialOffer = {}, specialOfferQuote, flight = {}, quoteInsurances = []) => {
		if (get(quoteInsurances, "insurancesItem.length", 0) === 0) {
			return false;
		}
		if (specialOffer && specialOffer.type !== SPECIAL_OFFER_TYPES.REFUNDABLE) {
			return true;
		}
		return !specialOfferQuote && !flight.specialOffer;
	}
);

export const hasOptionFlex = createSelector(
	[getQuotationInsurances, getPassengers, calculateQuoteBaseAndExtrasTotal],
	(insurances = {}, passengers = [], total) => {
		const flexInsurances = insurances.insurancesItem;
		const nbPassengers = passengers?.length || 0;
		const assuranceFlex = flexInsurances?.find(
			insurance => insurance.code !== INSURANCE_STANDARD
		);
		if (flexInsurances?.length === 0 || !assuranceFlex) {
			return false;
		}
		const flexIncluded = calculateFlexIncluded(assuranceFlex, total, nbPassengers);
		return flexIncluded !== 0;
	}
);
